import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import './MetricsFilter.scss';

class MetricsFilter extends Component {
  state = {
    activeFilter: 0
  }

  get filtersData() {
    return [
      {
        title: window.langs.allMetrics
      }
      // {
      //   title: 'CPA'
      // },
      // {
      //   title: 'CPS'
      // },
      // {
      //   title: 'LTCV'
      // },
      // {
      //   title: 'ARPU'
      // },
      // {
      //   title: 'ARPPU'
      // },
      // {
      //   title: 'ROI'
      // },
      // {
      //   title: 'Margin'
      // }
    ];
  }

  get filters() {
    const filters = this.filtersData;
    const { activeFilter } = this.state;

    return (
      filters.map((filter, index) => {
        const classes = classNames({
          'metrics-filter__item': true,
          'metrics-filter__item_active': activeFilter === index
        });

        return (
          <div className={classes} key={`metrics-filter-item-${ index }`}>
            { filter.title }
          </div>
        )
      })
    )
  }

  render() {
    return (
      <div className="metrics-filter">
        { this.filters }
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { language } = state;

  return {
    currentLang: language.current
  };
}

export default connect(mapStateToProps)(MetricsFilter);


// WEBPACK FOOTER //
// ./src/components/MetricsFilter/MetricsFilter.js